// extracted by css-extract-rspack-plugin
var _1 = "bn52YinzBgiOX9uU";
var _2 = "aOBDFqgFhIz3hXHi";
var _3 = "a7CTIIYsmW0G29j1";
var _4 = "bMv55l36v3UtYBAH";
var _5 = "dv7RoDfdeY4XNymj";
var _6 = "LIL7fS5VqsyZxL0s";
var _7 = "FTz9UTGPbEwq5Arl";
export { _1 as "cardDetailDotsOffset", _2 as "galleryFrame", _3 as "galleryHolder", _4 as "planSlide", _5 as "slide", _6 as "slideClickable", _7 as "sliderGallery" }
// extracted by css-extract-rspack-plugin
var _1 = "bn52YinzBgiOX9uU";
var _2 = "aOBDFqgFhIz3hXHi";
var _3 = "a7CTIIYsmW0G29j1";
var _4 = "bMv55l36v3UtYBAH";
var _5 = "dv7RoDfdeY4XNymj";
var _6 = "LIL7fS5VqsyZxL0s";
var _7 = "FTz9UTGPbEwq5Arl";
export { _1 as "cardDetailDotsOffset", _2 as "galleryFrame", _3 as "galleryHolder", _4 as "planSlide", _5 as "slide", _6 as "slideClickable", _7 as "sliderGallery" }
